import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';
import {
	Placeholder,
	ButtonGroup,
	Button,
	Dashicon,
	Modal,
	TabPanel,
	TabList,
	Tab,
	PanelRow,
	PanelColumn,
	RangeControl,
	BaseControl,
	Popover,
	ToggleControl,
	TextControl,
	SelectControl,
} from '@wordpress/components';
import InspectorSelectButton from '../inspector-select-button';
import InspectorColorSelect from '../inspector-color-select';
import InspectorImageSelector from '../inspector-image-selector';
import InspectorResponsiveRangeControl from '../inspector-responsive-range-control'; // Import InspectorResponsiveRangeControl
import PexelsSearchModal from '../PexelsSearchModal';

const InspectorBackgroundControlTab = ( props ) => {
	const { value, onChange = () => {} } = props;
	const [ isPexelsModalOpen, setIsPexelsModalOpen ] = useState( false );
	const [ enableBackground, setEnableBackground ] = useState(
		value?.enableBackground
	);
	const [ backgroundType, setBackgroundType ] = useState(
		value?.backgroundType
	);
	const [ backgroundColorGradient, setBackgroundColorGradient ] = useState(
		value?.backgroundColorGradient
	);
	const [ backgroundOpacity, setBackgroundOpacity ] = useState( // New state for backgroundOpacity
		value?.backgroundOpacity
	);
	const [ backgroundImageUrl, setBackgroundImageUrl ] = useState(
		value?.backgroundImageUrl
	);
	const [ backgroundImage, setBackgroundImage ] = useState(
		value?.backgroundImage
	);
	const [ backgroundSize, setBackgroundSize ] = useState(
		value?.backgroundSize
	);
	const [ backgroundPosition, setBackgroundPosition ] = useState(
		value?.backgroundPosition
	);
	const [ backgroundRepeat, setBackgroundRepeat ] = useState(
		value?.backgroundRepeat
	);
	const [ backgroundAttachment, setBackgroundAttachment ] = useState(
		value?.backgroundAttachment
	);

	useEffect( () => {
		onChange( {
			...value,
			enableBackground,
			backgroundType,
			backgroundColorGradient,
			backgroundOpacity, // Add backgroundOpacity to onChange
			backgroundImageUrl,
			backgroundImage,
			backgroundSize,
			backgroundPosition,
			backgroundRepeat,
			backgroundAttachment,
		} );
		console.log( 'Background Image: ', value );
	}, [
		enableBackground,
		backgroundType,
		backgroundColorGradient,
		backgroundOpacity, // Add backgroundOpacity to dependency array
		backgroundImageUrl,
		backgroundImage,
		backgroundSize,
		backgroundPosition,
		backgroundRepeat,
		backgroundAttachment,
	] );

	const onReset = () => {
		// setFontFamily(props?.defaultAttributes?.fontFamily);
		// setFontStyle(props?.defaultAttributes?.fontStyle);
		// setFontWeight(props?.defaultAttributes?.fontWeight);
		// setFontTransform(props?.defaultAttributes?.fontTransform);
		// setFontDecoration(props?.defaultAttributes?.fontDecoration);
	};

	return (
		<>
			<PexelsSearchModal
				isOpen={ isPexelsModalOpen }
				onClose={ () => setIsPexelsModalOpen( false ) }
				onSelect={ ( url ) => {
					setBackgroundImageUrl( url );
					setBackgroundType( 'url' );
					setIsPexelsModalOpen( false );
				} }
			/>
			{ /* <PanelBody title={__('Background', 'alpha')} className="!rounded-none !bg-transparent" initialOpen={false}> */ }
			<BaseControl>
				<ToggleControl
					label={ __( 'Enable Background', 'alpha' ) }
					checked={ value?.enableBackground === true }
					onChange={ ( val ) => setEnableBackground( val ) }
					__nextHasNoMarginBottom={ true }
				/>
			</BaseControl>
			{ enableBackground === true && (
				<>
					<BaseControl>
						<InspectorSelectButton
							label={ __( 'Background Type', 'alpha' ) }
							value={ value?.backgroundType || 'color' }
							onChange={ ( val ) => setBackgroundType( val ) }
							options={ [
								{
									value: 'color-gradient',
									iconName: 'paint-brush',
									label: __( 'Color Gradient', 'alpha' ),
								},
								{
									value: 'image',
									iconName: 'image',
									label: __( 'Image', 'alpha' ),
								},
								{
									value: 'url',
									iconName: 'chain',
									label: __( 'Url', 'alpha' ),
								},
							] }
							iconButton
						/>
					</BaseControl>
					{ backgroundType === 'color-gradient' && (
						<>
							<BaseControl>
								<InspectorColorSelect
									label={ __( 'Background Color', 'alpha' ) }
									value={ value?.backgroundColorGradient }
									onChange={ ( val ) =>
										setBackgroundColorGradient( val )
									}
									// defaultValue={defaultAttributes?.backgroundColorGradient?.default}
									disableCustomColors={ false }
									disableAlpha={ false }
									showReset={ true }
								/>
							</BaseControl>
							<InspectorResponsiveRangeControl
								label={ __( 'Background Opacity', 'alpha' ) }
								value={ value?.backgroundOpacity }
								onChange={ ( val ) => setBackgroundOpacity( val ) }
								min={ 0 }
								max={ 100 }
								step={ 1 }
								unit={ false }
							/>
						</>
					) }
					{ backgroundType === 'image' && (
						<BaseControl>
							<InspectorImageSelector
								label={ __( 'Background Image', 'alpha' ) }
								value={ value?.backgroundImage }
								onChange={ ( val ) =>
									setBackgroundImage( val )
								}
							/>
						</BaseControl>
					) }
					{ backgroundType === 'url' && (
						<BaseControl>
							<TextControl
								label={ __( 'Background Image Url', 'alpha' ) }
								value={ value?.backgroundImageUrl }
								onChange={ ( val ) =>
									setBackgroundImageUrl( val )
								}
							/>
							<Button
								isSecondary
								onClick={ () => setIsPexelsModalOpen( true ) }
								style={{width: '100%', justifyContent: 'center'}}
							>
								{ __( 'Search Pexels for Image', 'alpha' ) }
							</Button>
						</BaseControl>
					) }
					{ ( backgroundType === 'image' ||
						backgroundType === 'url' ) && (
						<>
							<BaseControl>
								<InspectorSelectButton
									label={ __( 'Background Size', 'alpha' ) }
									value={ value?.backgroundSize || 'cover' }
									onChange={ ( val ) =>
										setBackgroundSize( val )
									}
									options={ [
										{
											value: 'auto',
											label: __( 'Auto', 'alpha' ),
										},
										{
											value: 'cover',
											label: __( 'Cover', 'alpha' ),
										},
										{
											value: 'contain',
											label: __( 'Contain', 'alpha' ),
										},
									] }
								/>
							</BaseControl>
							<BaseControl>
								<SelectControl
									label={ __(
										'Background Position',
										'alpha'
									) }
									value={
										value?.backgroundPosition ||
										'center center'
									}
									onChange={ ( val ) =>
										setBackgroundPosition( val )
									}
									options={ [
										{
											value: 'left top',
											label: __( 'Left Top', 'alpha' ),
										},
										{
											value: 'left center',
											label: __( 'Left Center', 'alpha' ),
										},
										{
											value: 'left bottom',
											label: __( 'Left Bottom', 'alpha' ),
										},
										{
											value: 'right top',
											label: __( 'Right Top', 'alpha' ),
										},
										{
											value: 'right center',
											label: __(
												'Right Center',
												'alpha'
											),
										},
										{
											value: 'right bottom',
											label: __(
												'Right Bottom',
												'alpha'
											),
										},
										{
											value: 'center top',
											label: __( 'Center Top', 'alpha' ),
										},
										{
											value: 'center center',
											label: __(
												'Center Center',
												'alpha'
											),
										},
										{
											value: 'center bottom',
											label: __(
												'Center Bottom',
												'alpha'
											),
										},
									] }
								/>
							</BaseControl>
							<BaseControl>
								<InspectorSelectButton
									label={ __( 'Background Repeat', 'alpha' ) }
									value={
										value?.backgroundRepeat || 'no-repeat'
									}
									onChange={ ( val ) =>
										setBackgroundRepeat( val )
									}
									options={ [
										{
											value: 'no-repeat',
											label: __( 'No Repeat', 'alpha' ),
										},
										{
											value: 'repeat',
											label: __( 'Repeat', 'alpha' ),
										},
										{
											value: 'repeat-x',
											label: __( 'Repeat X', 'alpha' ),
										},
										{
											value: 'repeat-y',
											label: __( 'Repeat Y', 'alpha' ),
										},
									] }
								/>
							</BaseControl>
							<BaseControl>
								<InspectorSelectButton
									label={ __(
										'Background Attachment',
										'alpha'
									) }
									value={
										value?.backgroundAttachment || 'scroll'
									}
									onChange={ ( val ) =>
										setBackgroundAttachment( val )
									}
									options={ [
										{
											value: 'scroll',
											label: __( 'Scroll', 'alpha' ),
										},
										{
											value: 'fixed',
											label: __( 'Fixed', 'alpha' ),
										},
										{
											value: 'local',
											label: __( 'Local', 'alpha' ),
										},
									] }
								/>
							</BaseControl>
						</>
					) }
				</>
			) }
			{ /* </PanelBody>             */ }
		</>
	);
};

export default InspectorBackgroundControlTab;
